// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5271) return "5271.f1ee3bcb437a9ad9031c.js";
	// return url for filenames based on template
	return "" + {"1167":"c8c1db03577bdcb509f3","3345":"57ec571fe0a70fa2f90a"}[chunkId] + ".js";
};